import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('submitting');
    // Simulate API call
    setTimeout(() => {
      setFormState('success');
      console.log('Form submitted successfully');
    }, 1500);
  };
  return <section id="contact" className="py-24 bg-slate-50" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-41">
          {/* Contact Info */}
          <div data-id="element-42">
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6" data-id="element-43">
              Get a Free Quote
            </h2>
            <p className="text-lg text-slate-600 mb-10" data-id="element-44">
              Whether you want to get on our weekly service route or need a
              complex repair, we're here to help. Fill out the form or give us a
              call.
            </p>

            <div className="space-y-8" data-id="element-45">
              <div className="flex items-start gap-4" data-id="element-46">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center shrink-0" data-id="element-47">
                  <Phone className="w-6 h-6 text-blue-600" data-id="element-48" />
                </div>
                <div data-id="element-49">
                  <h4 className="font-bold text-slate-900 text-lg mb-1" data-id="element-50">
                    Call Us
                  </h4>
                  <a href="tel:4802998477" className="text-slate-600 hover:text-blue-600 text-lg transition-colors" data-id="element-51">
                    (480) 299-8477
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-52">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center shrink-0" data-id="element-53">
                  <Mail className="w-6 h-6 text-blue-600" data-id="element-54" />
                </div>
                <div data-id="element-55">
                  <h4 className="font-bold text-slate-900 text-lg mb-1" data-id="element-56">
                    Email Us
                  </h4>
                  <a href="mailto:crystalwaterpoolspa@gmail.com" className="text-slate-600 hover:text-blue-600 text-lg transition-colors" data-id="element-57">
                    crystalwaterpoolspa@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-58">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center shrink-0" data-id="element-59">
                  <MapPin className="w-6 h-6 text-blue-600" data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <h4 className="font-bold text-slate-900 text-lg mb-1" data-id="element-62">
                    Service Area
                  </h4>
                  <p className="text-slate-600 text-lg" data-id="element-63">
                    Gilbert, Chandler, Mesa, and the East Valley
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100" data-id="element-64">
            {formState === 'success' ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-65">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6" data-id="element-66">
                  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-67">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-68" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-69">
                  Message Sent!
                </h3>
                <p className="text-slate-600" data-id="element-70">
                  We'll get back to you shortly with your free quote.
                </p>
                <button onClick={() => setFormState('idle')} className="mt-8 text-blue-600 font-medium hover:underline" data-id="element-71">
                  Send another message
                </button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-72">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-73">
                  <div data-id="element-74">
                    <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-75">
                      Full Name
                    </label>
                    <input type="text" id="name" required className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition-all" placeholder="John Doe" data-id="element-76" />
                  </div>
                  <div data-id="element-77">
                    <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-78">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" required className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition-all" placeholder="(480) 555-0123" data-id="element-79" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-80">
                  <div data-id="element-81">
                    <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-82">
                      Email Address
                    </label>
                    <input type="email" id="email" required className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition-all" placeholder="john@example.com" data-id="element-83" />
                  </div>
                  <div data-id="element-84">
                    <label htmlFor="zip" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-85">
                      Zip Code
                    </label>
                    <input type="text" id="zip" required className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition-all" placeholder="95765" data-id="element-86" />
                  </div>
                </div>

                <div data-id="element-87">
                  <label htmlFor="service" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-88">
                    What do you need help with?
                  </label>
                  <select id="service" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition-all bg-white" data-id="element-89">
                    <option data-id="element-90">Weekly Route Service</option>
                    <option data-id="element-91">Pool Repair</option>
                    <option data-id="element-92">Tile & Calcium Cleaning</option>
                    <option data-id="element-93">Equipment Upgrade</option>
                    <option data-id="element-94">Other</option>
                  </select>
                </div>

                <div data-id="element-95">
                  <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-96">
                    Message (Optional)
                  </label>
                  <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us about your pool..." data-id="element-97"></textarea>
                </div>

                <button type="submit" disabled={formState === 'submitting'} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 rounded-xl font-bold text-lg transition-all disabled:opacity-70 flex justify-center items-center" data-id="element-98">
                  {formState === 'submitting' ? <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-99" /> : 'Request Free Quote'}
                </button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}